import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TemplateRoleComponent} from './template-role.component';

@NgModule({
  imports: TemplateRoleModule.IMPORTS,
  declarations: TemplateRoleModule.DECLARATIONS,
  exports: TemplateRoleModule.DECLARATIONS
})
export class TemplateRoleModule {
  public static readonly IMPORTS: any[] = [CommonModule];

  public static readonly DECLARATIONS: any[] = [TemplateRoleComponent];
}
